import { api } from "./api";

const KEY = "livyvio_goal";

export const GOALS = {
  goalLose: { topics: ["weight", "nutrition"] },
  goalMuscle: { topics: ["fitness"] },
  goalEat: { topics: ["nutrition"] },
  goalFit: { topics: ["fitness"] },
  goalPerf: { topics: ["fitness"] },
  goalSleep: { topics: ["sleep"] },
  goalFeel: { topics: ["sleep", "nutrition"] },
};

function isAuthed() {
  try { return !!localStorage.getItem("livyvio_token"); } catch { return false; }
}
export function getGoal() {
  try { return localStorage.getItem(KEY) || null; } catch { return null; }
}
export function setGoal(g) {
  try { localStorage.setItem(KEY, g); } catch {}
  if (isAuthed()) api.patch("/api/me/preferences", { goal: g }).catch(() => {});
}
export function clearGoal() {
  try { localStorage.removeItem(KEY); } catch {}
  if (isAuthed()) api.patch("/api/me/preferences", { goal: "" }).catch(() => {});
}

// Lightweight reorder: items whose topics intersect the goal's topics come first.
export function prioritize(items, goal) {
  if (!goal || !items) return items;
  const topics = GOALS[goal]?.topics || [];
  return [...items].sort((a, b) => {
    const am = (a.topics || []).some((t) => topics.includes(t)) ? 1 : 0;
    const bm = (b.topics || []).some((t) => topics.includes(t)) ? 1 : 0;
    return bm - am;
  });
}
